import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Header from "../../layout/Header";
import PersonalInfoSection from "./components/PersonalInfoSection";
import PhysicalDetailsSection from "./components/PhysicalDetailsSection";
import SubscriptionSection from "./components/SubscriptionSection";
import ActionButtons from "./components/ActionButtons";
import DeleteConfirmationModal from "./components/DeleteConfirmationModal";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  createTrainerService,
  deleteTrainerService,
  getTrainerByIdService,
  getTrainersService,
  updateTrainerService,
} from "redux/services/trainers_service";
import { useLanguage } from "LanguageContext";
import {
  createDepartmentService,
  deleteDepartmentService,
  getDepartmentByIdService,
  updateDepartmentService,
} from "redux/services/departments_service";

const AddEditDepartmentProfile = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();

  const { departmentInfo } = useSelector((state) => state.departments);

  const { language } = useLanguage();

  const [isEditMode, setIsEditMode] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isArabic, setIsArabic] = useState(language == "ar" ? true : false);
  const [formData, setFormData] = useState({
    name: isEditMode ? departmentInfo?.name : "",
    image: null,
  });
  const [errors, setErrors] = useState({});

  const queryParams = new URLSearchParams(location.search);
  const trainerId = queryParams.get("id");

  useEffect(() => {
    //  const trainerId = location.state?.id;
    if (trainerId) {
      setIsEditMode(true);

      dispatch(getDepartmentByIdService(trainerId)).then((response) => {
        console.log(response?.payload?.data?.data);
        if (response.payload.status == 200) {
          setFormData(response?.payload?.data?.data);
        }
      });
    }
  }, [location]);

  const onImageChange = (file) => {
    setFormData((prev) => ({
      ...prev,
      image: file,
    }));
    // Clear error when user selects an image
    if (errors.image) {
      setErrors((prev) => ({
        ...prev,
        image: "",
      }));
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear error when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  // Validation function
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = isArabic ? "الاسم  مطلوب" : " name is required";
    }
    if (!formData.image) {
      newErrors.image = isArabic ? "الصورة مطلوبة" : "Image is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    console.log(formData);
    const formsData = new FormData();
    formsData.append("name", formData?.name);
    formsData.append("image", formData?.image);
    if (validateForm()) {
      if (isEditMode !== true) {
        dispatch(createDepartmentService(formsData))
          .then((response) => {
            console.log(response);
            if (
              response?.payload?.status === 200 ||
              response?.payload?.status === 201
            ) {
              toast.success(
                language === "ar"
                  ? "  تمت عملية الإضافة بنجاح "
                  : "Added successfully !"
              );
              navigate("/departments");
            } else {
              Object.values(response.payload.errors).forEach((errorArray) => {
                errorArray.forEach((errorMessage) => {
                  toast.warn(errorMessage);
                });
              });
            }
          })
          .catch((error) => {
            console.error(error);
            toast.error("An error occurred");
          })
          .finally(() => {
            //   setLoading(false); // Stop loading
          });
      } else {
        dispatch(
          updateDepartmentService({ id: trainerId, formData: formsData })
        )
          .then((response) => {
            console.log(response);
            if (
              response?.payload?.status === 200 ||
              response?.payload?.status === 201
            ) {
              toast.success(
                language === "ar"
                  ? "  تمت عملية التعديل بنجاح "
                  : "Updated successfully !"
              );
              navigate("/departments");
            } else {
              Object.values(response.payload.errors).forEach((errorArray) => {
                errorArray.forEach((errorMessage) => {
                  toast.warn(errorMessage);
                });
              });
            }
          })
          .catch((error) => {
            console.error(error);
            toast.error("An error occurred");
          })
          .finally(() => {
            //   setLoading(false); // Stop loading
          });
      }

      // navigate('/client-management');
    }
  };

  const handleCancel = () => {
    navigate("/departments");
  };

  const handleDelete = () => {
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    dispatch(deleteDepartmentService(trainerId)).then((response) => {
      if (
        response.payload?.status === 200 ||
        response.payload?.status === 201 ||
        response.payload?.status === 204
      ) {
        toast.success(
          language === "ar" ? "تم الحذف بنجاح" : "Deleted successfully"
        );

        dispatch(getTrainersService({ page: 1 }));
        setShowDeleteModal(false);
        navigate("/departments");
      }
    });
  };

  return (
    <div
      className={`min-h-screen bg-gray-50 ${isArabic ? "rtl" : "ltr"}`}
      dir={isArabic ? "rtl" : "ltr"}
    >
      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="p-8">
            <div className="max-w-2xl mx-auto">
              <PersonalInfoSection
                formData={formData}
                errors={errors}
                isArabic={isArabic}
                onInputChange={handleInputChange}
                onImageChange={onImageChange}
              />

              <ActionButtons
                isEditMode={isEditMode}
                isArabic={isArabic}
                onSave={handleSave}
                onCancel={handleCancel}
                onDelete={handleDelete}
              />
            </div>
          </div>
        </div>
      </main>

      {showDeleteModal && (
        <DeleteConfirmationModal
          isArabic={isArabic}
          clientName={clientInfo?.name}
          onConfirm={confirmDelete}
          onCancel={() => setShowDeleteModal(false)}
        />
      )}
    </div>
  );
};

export default AddEditDepartmentProfile;
